export default __webpack_public_path__ + "static/media/sienna-hirebus.5f312426.png";